/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import {
    DataGridPremium,
    DataGridPremiumProps,
} from '@mui/x-data-grid-premium';
import { SxProps, Theme } from '@mui/material/styles';

export function SimpleDataGrid(
    props: DataGridPremiumProps & { customSx?: SxProps<Theme> }
) {
    return (
        <DataGridPremium
            hideFooter
            disableColumnMenu
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
            disableRowSelectionOnClick
            rowHeight={40}
            columnHeaderHeight={40}
            slots={{
                noRowsOverlay: SimpleNoRowsOverlay,
            }}
            sx={[
                simpleTableGridSx,
                {
                    '& .MuiDataGrid-columnSeparator': {
                        display: props.disableColumnResize ? 'none' : 'flex',
                    },
                },
                ...(Array.isArray(props.customSx)
                    ? props.customSx
                    : [props.customSx]),
            ]}
            {...props}
        />
    );
}

function SimpleNoRowsOverlay() {
    return <div style={{ padding: 16, color: '#777' }}>No data</div>;
}

const simpleTableGridSx = {
    border: '1px solid #d9d9d9',
    borderRadius: 0,
    fontFamily: 'Nunito Sans, sans-serif',

    // Header
    '--DataGrid-containerBackground': '#F5F5F5',
    '& .MuiDataGrid-columnHeaders': {
        borderBottom: '1px solid #CCCCCC',
    },

    '& .MuiDataGrid-columnHeaderTitle': {
        fontWeight: 700,
        fontSize: 16,
        color: '#333',
    },

    // Rows
    '& .MuiDataGrid-cell': {
        borderBottom: '1px solid #e5e5e5',
        fontSize: 16,
        color: '#333',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },

    '& .MuiDataGrid-columnSeparator': {
        display: 'flex',
        visibility: 'visible',
        color: '#ccc',
    },

    '& .MuiDataGrid-row:hover': {
        backgroundColor: '#fafafa',
    },

    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
        outline: 'none',
    },

    '& .MuiDataGrid-row.Mui-selected': {
        backgroundColor: 'transparent',
    },
    '& .MuiDataGrid-virtualScroller': {
        overflowX: 'auto',
    },

    '& .MuiTablePagination-root': {
        fontSize: '14px',
    },

    '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
        fontSize: '14px',
    },
    '& .MuiTablePagination-displayedRows': {
        margin: 0,
    },

    '& .MuiTablePagination-select': {
        fontSize: '14px',
    },
    '& .MuiTablePagination-actions': {
        fontSize: '14px',
    },
};
